var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightBlue2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 479,
    viewBox: "0 0 179 479",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.677 478.135C122.804 464.087 63.3326 451.387 1.10233 440.373V70.7381C63.3326 50.3964 122.804 27.0202 177.677 1.39636V478.135Z",
    fill: "#00C8D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.166 2.18346V477.461C122.498 463.525 63.5371 450.938 1.6134 439.924V71.188C63.5371 50.9587 122.498 27.6949 177.166 2.18346ZM178.188 0.497681C123.008 26.3463 63.6393 49.7225 0.591553 70.289V440.823C63.6393 452.062 123.008 464.762 178.188 478.81V0.497681Z",
    fill: "#00C8D5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBlue2);
export default __webpack_public_path__ + "static/media/RightBlue2.f03f381a214c192c4aee65899c5cc793.svg";
export { ForwardRef as ReactComponent };